import { createHeadlessEditor } from './createHeadlessEditor';
import * as plateFunctions from './plateFunctions';
import * as plateHooks from './plateHooks';
import * as plateTypes from './plateTypes';

export * from './deserialize';
export * from './myCreatePlugins';
export * from './plugins';
export * from './structure';
export * from './utils';

/**
 * This prevents 'Invalid value for prop `data-slate-editor-id`' error. Because
 * ID of Plate is a Symbol
 */
export const PLATE_ID = 'knowledge_editor';

export { createHeadlessEditor, plateFunctions, plateHooks, plateTypes };
